<template>
  <b-list-group>
    <template v-for="(section, idx) in helpSections">
      <b-list-group-item
        v-if="section.questions.length"
        :key="idx"
        class="d-flex justify-content-between align-items-center cursor-pointer"
        @click="$emit('select', section)"
      >
        {{ getTranslatedField(section, 'name') }}
        <b-badge
          variant="light-secondary"
          pill
        >
          {{ section.questions.length }}
        </b-badge>
      </b-list-group-item>
    </template>
  </b-list-group>
</template>

<script>
import { mapGetters } from 'vuex'
import {
  BListGroup, BListGroupItem, BBadge,
} from 'bootstrap-vue'
import LocalizationMixin from '@/mixins/localization-mixin'

export default {
  name: 'HelpSectionsList',
  components: {
    BListGroup, BListGroupItem, BBadge,
  },
  mixins: [LocalizationMixin],
  computed: {
    ...mapGetters({
      helpSections: 'help/questionSections',
    }),
  },
}
</script>
